import React, { Component} from 'react'
import { Link } from 'react-router-dom'

class SentInfo extends Component
{
  render() {
    return(
      <React.Fragment>
        <main>
          <div className="content ">
            <section className="header-type-2">
              <h1>
                빠르고 편리하게 꺼내보는
                <br/>
                전자문서보관센터
              </h1>

              <h4 className="m-t-20">
                전자문서 원문 그대로 블록체인에 저장하는 전자문서보관센터로 분실 및 훼손,
                <br/>
                필요 시 일일이 찾아야 하는 번거로움,
                <br/>
                과다한 보관비용 등의 문제가 해결됩니다.
              </h4>
            </section>
          </div>
        </main>

      </React.Fragment>
    )
  }
}

export default SentInfo
